module.exports = __webpack_public_path__ + "static/media/138.64561b32.jpg";